<template>
  <div class="Relationship">
    <secBanner></secBanner>
    <el-container class="container content-area">
      <el-aside class="aside-area" width="260px">
        <ul>
          <li class="lead">服务与合作</li>
          <li>
            <router-link to="/relationship/notice" active-class="cur">公司公告</router-link>
          </li>
          <li>
            <router-link to="/relationship/members" active-class="cur">董事会成员</router-link>
          </li>
        </ul>
      </el-aside>
      <div class="sub-content-area">
        <div class="breadcrumb-nav">
          您的位置：
          <!-- <router-link to="/" title="首页">首页</router-link>> -->
          <router-link to="/relationship" title="投资者关系">投资者关系</router-link>
          <span>>&nbsp;{{this.$route.name}}</span>
        </div>
        <router-view></router-view>
      </div>
    </el-container>
  </div>
</template>
<script>
import secBanner from '@/components/assembly/sec-banner'
export default {
  data () {
    return {
    }
  },
  components: {
    secBanner
  }

}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Relationship.vue